import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import SuperadminClients from "@/pages/superadmin/SuperadminClients";
import AdminDashboard from "@/pages/AdminDashboard";
import GestioneUtenti from "@/pages/admin/GestioneUtenti";
import GestioneCompetizioni from "@/pages/admin/GestioneCompetizioni";
import GestioneRisultati from "@/pages/admin/GestioneRisultati";
import RisultatoDetail from "@/pages/admin/RisultatoDetail";
import Classifica from "@/pages/admin/tools/Classifica";
import Ricerca from "@/pages/admin/tools/Ricerca";
import Export from "@/pages/admin/tools/Export";
import GestioneCertificati from "@/pages/admin/GestioneCertificati";
import ResponsabileDashboard from "@/pages/ResponsabileDashboard";
import MieCompetizioni from "@/pages/responsabile/MieCompetizioni";
import CompetizioneDetail from "@/pages/responsabile/CompetizioneDetail";
import DanceAnalysis from "@/pages/responsabile/DanceAnalysis";
import JudgeCompetition from "@/pages/responsabile/JudgeCompetition";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/superadmin/login" element={<Login superadmin />} />
            <Route
              path="/superadmin"
              element={<ProtectedRoute superadmin><SuperadminClients /></ProtectedRoute>}
            />

            <Route
              path="/admin"
              element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>}
            />
            <Route
              path="/admin/utenti"
              element={<ProtectedRoute role="admin"><GestioneUtenti /></ProtectedRoute>}
            />
            <Route
              path="/admin/competizioni"
              element={<ProtectedRoute role="admin"><GestioneCompetizioni /></ProtectedRoute>}
            />
            <Route
              path="/admin/risultati"
              element={<ProtectedRoute role="admin"><GestioneRisultati /></ProtectedRoute>}
            />
            <Route
              path="/admin/risultati/:id"
              element={<ProtectedRoute role="admin"><RisultatoDetail /></ProtectedRoute>}
            />
            <Route
              path="/admin/tools/classifica"
              element={<ProtectedRoute role="admin"><Classifica /></ProtectedRoute>}
            />
            <Route
              path="/admin/tools/ricerca"
              element={<ProtectedRoute role="admin"><Ricerca /></ProtectedRoute>}
            />
            <Route
              path="/admin/tools/export"
              element={<ProtectedRoute role="admin"><Export /></ProtectedRoute>}
            />
            <Route
              path="/admin/certificati"
              element={<ProtectedRoute role="admin"><GestioneCertificati /></ProtectedRoute>}
            />

            <Route
              path="/responsabile"
              element={<ProtectedRoute role="responsabile"><ResponsabileDashboard /></ProtectedRoute>}
            />
            <Route
              path="/responsabile/competizioni"
              element={<ProtectedRoute role="responsabile"><MieCompetizioni /></ProtectedRoute>}
            />
            <Route
              path="/responsabile/competizioni/:id"
              element={<ProtectedRoute role="responsabile"><CompetizioneDetail /></ProtectedRoute>}
            />
            <Route
              path="/responsabile/dance-analysis"
              element={<ProtectedRoute role="responsabile"><DanceAnalysis /></ProtectedRoute>}
            />
            <Route
              path="/responsabile/dance-analysis/:id"
              element={<ProtectedRoute role="responsabile"><JudgeCompetition /></ProtectedRoute>}
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
